
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'UI2BillingDetails',
  data() {
    return {
      emailEmpty: false,
      validBillingEmail: true
    }
  },
  props: {
    email: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    }
  },
  computed: {
    emailValue: {
      get() {
        return this.email
      },
      set(value: string) {
        this.$emit('update:email', value)
      }
    },
    addressValue: {
      get() {
        return this.address
      },
      set(value: string) {
        this.$emit('update:address', value)
      }
    }
  },
  methods: {
    validateEmail(el: HTMLInputElement): void {
      this.emailValue = el.value
      this.validBillingEmail = el.checkValidity()
      if (!this.emailValue) {
        this.emailEmpty = true
        return
      }
      this.emailEmpty = false
    },
    onChange() {
      this.$emit('update', {
        email: this.emailValue,
        address: this.addressValue
      })
    }
  }
})
